export class BomDto {
  bomId?: number;
  itemName?: string;
  imCode?: string;
  description?: string;
  createdUser?: string;
  isActive?: boolean;
  versionFlag?: number;
  updatedUser?: string;
  updatedAt?: string;
  itemId?: string;
  sequence?: number;
  styleId?: number;
  vendorName?: string;
  orderForm?: string;
  constructor(
    bomId: number,
    itemName: string,
    imCode: string,
    description: string,
    createdUser: string,
    isActive?: boolean,
    versionFlag?: number,
    updatedUser?: string,
    updatedAt?: string,
    itemId?: string,
    sequence?: number,
    styleId?: number,
    vendorName?: string,
    orderForm?: string
  ) {
    this.bomId = bomId;
    this.itemName = itemName;
    this.imCode = imCode;
    this.description = description;
    this.createdUser = createdUser;
    this.isActive = isActive;
    this.versionFlag = versionFlag;
    this.updatedUser = updatedUser;
    this.updatedAt = updatedAt;
    this.itemId = itemId;
    this.sequence = sequence;
    this.styleId = styleId;
    this.vendorName = vendorName;
    this.orderForm = orderForm;
  }
}
